<template>
  <div>
    <b-modal
      v-if="showUploadPlayerMinsCSV"
      v-model="showUploadPlayerMinsCSV"
      size="lg"
      :hide-footer="Boolean(true)"
      @hide="resetGPSUploadModal"
    >
      <div>
        <h2>Import CSV file</h2>
        <div class="example-template">
          <a @click="downloadCSVData('Catapult')" target="_blank">
            <i class="bi bi-file-spreadsheet" aria-hidden="true"></i> Download
            the example Catapult template</a
          >

          <a @click="downloadCSVData('Playermaker')" target="_blank">
            <i class="bi bi-file-spreadsheet" aria-hidden="true"></i> Download
            the example Playermaker template</a
          >
        </div>
        <hr />

        <div class="type-of-csv-import">
          <h3>
            {{ gameTrainingData.gameType }} {{ gameTrainingData.matchDate }}
            {{ gameTrainingData.teamName }} v {{ gameTrainingData.opposition }}
          </h3>

          <h4>Select data upload type</h4>

          <b-form-group class="radios-group-gps">
            <b-form-radio
              v-model="gpsUploadDataTypeSelected"
              name="catapult-radios"
              value="catapult"
              ><img src="./img/cat-gps.jpg"
            /></b-form-radio>
            <b-form-radio
              v-model="gpsUploadDataTypeSelected"
              name="playermaker-radios"
              value="playermaker"
              ><img src="./img/playMaker.jpg"
            /></b-form-radio>
          </b-form-group>
        </div>

        <div
          class="upload-wrapper"
          v-if="gpsUploadDataTypeSelected !== undefined"
        >
          <label
            >File
            <input type="file" @change="importCSV($event)" />
          </label>

          <div v-if="csvDataImported !== null" class="show-imported-CSV-data">
            <pre>{{ csvDataImported }}</pre>
          </div>

          <button
            v-if="csvDataImported !== null && validation === null"
            v-on:click="importUploadedCSVDataFile()"
          >
            Save
          </button>
        </div>
        <p class="days-red-warning" v-if="dataCSVErrorMessage !== null">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          {{ dataCSVErrorMessage }}
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { PlayerPhysicalPerformance } from "@/services/player-physical-performance-service.js";
export default {
  name: "GpsUploader",
  data() {
    return {
      showUploadPlayerMinsCSV: false,
      gpsUploadDataTypeSelected: "",
      dataCSVErrorMessage: null,
      csvDataImported: null,
      validation: null,
    };
  },
  props: {
    openGPSUploadModal: {
      type: Boolean,
      default: false,
    },
    gameTrainingData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    openGPSUploadModal: function (newVal) {
      if (newVal === true) {
        this.showUploadPlayerMinsCSV = true;
      }
    },
  },
  created() {},
  methods: {
    downloadCSVData(value) {
      const anchor = document.createElement("a");
      anchor.target = "_blank";

      if (value === "Catapult") {
        let csv =
          "player_id,Player Name,Period Name,Period Number,Date,Total Distance,Total Absolute High Speed Distance,Maximum Velocity,Max Vel (% Max),Accelerations Total Efforts,Decelerations Total Efforts,Meterage Per Minute,Unix Start Time,Unix End Time\n0,0,0,12/4/24,0,0,0,0,0,0,0,0,1728073452,1728070547";
        anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        anchor.download = "cat-template.csv";
      } else {
        let csv =
          "player_id,Date,Day,Session Type,Tag,Phase Duration (min),Player Name,Player Participation Time (min),Total Touches (#),Left Leg Touches (#),Right Leg Touches (#),Releases (#),Releases Left (#),Releases Right (#),Top Speed (m/s),Distance Covered (m),Work Rate (m/min)\n0,03/12/2024,Monday,Game,Game,0,Player 1,0,0,0,0,0,0,0,0,0,0";
        anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        anchor.download = "playMaker-template.csv";
      }

      anchor.click();
    },
    checkTemplateIsCorrect(results) {
      let requiredHeadings = [];

      if (this.gpsUploadDataTypeSelected === "catapult") {
        requiredHeadings = [
          "player_id",
          "Player Name",
          "Period Name",
          "Period Number",
          "Date",
          "Total Distance",
          "Total Absolute High Speed Distance",
          "Maximum Velocity",
          "Max Vel (% Max)",
          "Accelerations Total Efforts",
          "Decelerations Total Efforts",
          "Meterage Per Minute",
          "Unix Start Time",
          "Unix End Time",
        ];
      } else {
        requiredHeadings = [
          "player_id",
          "Date",
          "Day",
          "Session Type",
          "Tag",
          "Phase Duration (min)",
          "Player Name",
          "Player Participation Time (min)",
          "Total Touches (#)",
          "Left Leg Touches (#)",
          "Right Leg Touches (#)",
          "Releases (#)",
          "Releases Left (#)",
          "Releases Right (#)",
          "Top Speed (m/s)",
          "Distance Covered (m)",
          "Work Rate (m/min)",
        ];
      }

      // Validate input
      if (!Array.isArray(results) || results.length === 0) {
        console.warn("No results found or invalid data format.");
        this.validation = "No results found or invalid data format.";
        return false;
      }

      const object = results[0];
      console.log(object);

      const missingHeadings = requiredHeadings.filter(
        (heading) => !Object.prototype.hasOwnProperty.call(object, heading),
      );

      console.log(missingHeadings);

      if (missingHeadings.length > 0) {
        const missingFieldsMessage = `Missing fields: ${missingHeadings.join(", ")}`;
        console.warn(missingFieldsMessage);
        this.validation = missingFieldsMessage;
        this.dataCSVErrorMessage = missingFieldsMessage;
        return false;
      }
      return true;
    },
    async importCSV(e) {
      const file = e.target.files.item(0);
      const csv = await file.text();
      var lines = csv.split("\n");

      var result = [];

      var headers = lines[0].split(",");

      for (var i = 1; i < lines.length; i++) {
        var obj = {};
        var currentline = lines[i].split(",");

        if (currentline.length === 1) {
          console.log(currentline);
        } else {
          for (var j = 0; j < headers.length; j++) {
            console.log(currentline[j]);
            let str1 = currentline[j].replace(/\n|\r/g, "");
            let str2 = headers[j].replace(/\n|\r/g, "");
            obj[str2] = str1;
          }
          result.push(obj);
        }
      }
      this.checkTemplateIsCorrect(result);
      this.csvDataImported = result;
    },
    resetGPSUploadModal() {
      this.$emit("gpsUploadModalValue", false);
    },
    async importUploadedCSVDataFile() {
      this.gpsUploadDataTypeSelected === "catapult"
        ? this.saveCSVCatapultData()
        : this.saveCSVPlayermakerData();
    },
    checkCSVdata() {
      return this.gpsUploadDataTypeSelected === "catapult"
        ? Object.prototype.hasOwnProperty.call(
            this.csvDataImported[0],
            "Accelerations Total Efforts",
          )
        : Object.prototype.hasOwnProperty.call(this.csvDataImported[0], "Tag");
    },
    csvErrorMessage() {
      this.dataCSVErrorMessage =
        "Please verify that your CSV upload template is correct and that you have selected the appropriate upload option.";
      setTimeout(() => (this.dataCSVErrorMessage = null), 2000);
    },
    async saveCSVCatapultData() {
      const dataIsGood = this.checkCSVdata();

      if (dataIsGood === true) {
        const data = {
          action: "importUploadedCSVDataFile",
          data: this.csvDataImported,
          gameId: this.gameTrainingData.id,
          teamId: this.gameTrainingData.teamId,
        };
        const responce = await PlayerPhysicalPerformance.find(data).catch(
          (error) => {
            console.log(error);
          },
        );
        if (responce.status === 200) {
          //this.loadPlayerMinsPerformanceData();
          this.showUploadPlayerMinsCSV = false;

          this.$toast.success("CSV Catapult data added.", {
            title: "saved",
          });
        }
      } else {
        this.csvErrorMessage();
      }
    },
    fixDateForImport(date) {
      return date.substring(0, 10);
    },
    async saveCSVPlayermakerData() {
      const dataIsGood = this.checkCSVdata();
      if (dataIsGood === true) {
        this.csvDataImported[0].Date = this.fixDateForImport(
          this.csvDataImported[0].Date,
        );
        const data = {
          action: "importUploadedCSVDataForPlayMakerFile",
          data: this.csvDataImported,
          gameId: this.gameTrainingData.id,
          teamId: this.gameTrainingData.teamId,
        };
        const responce = await PlayerPhysicalPerformance.find(data).catch(
          (error) => {
            console.log(error);
          },
        );
        if (responce.status === 200) {
          //this.loadPlayerMinsPerformanceData();
          this.showUploadPlayerMinsCSV = false;

          this.$toast.success("CSV PlayMaker data added.", {
            title: "saved",
          });
        }
      } else {
        this.csvErrorMessage();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.example-template {
  border: 1px solid #d3d1d1;
  background: #f2f1f1;
  margin-bottom: 1rem;

  a {
    cursor: pointer;
    padding: 1rem;
    display: block;

    &:focus,
    &:hover {
      background: #abdeb6;
    }
  }
}
</style>
